import { IModalManager, MODAL_MANAGER } from '@cp/shared/modal';
import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { useInjection } from '@cp/shared/di';
import { ModalProvider } from './modalProvider';
import { RefModalManager } from './refManager';

export const AppModalManager: React.FC<PropsWithChildren> = (props) => {
  const manageRef = useRef<IModalManager>(null);
  const manager = useInjection(MODAL_MANAGER);

  useEffect(() => {
    if (!(manager instanceof RefModalManager)) {
      console.warn('Can not connect modal ref to current manager');
      return;
    }
    manager.connect(manageRef);
    return () => manager.disconnect();
  }, [manageRef, manager]);

  return (
    <>
      {props.children}
      <ModalProvider manageRef={manageRef} />
    </>
  );
};
AppModalManager.displayName = 'AppModalManager';
